import { motion } from "framer-motion";
import { DollarSign } from "lucide-react";

interface WDollarParticleProps {
  startX: number;
  startY: number;
  endX: number;
  endY: number;
  delay: number;
  onComplete: () => void;
}

export function WDollarParticle({ startX, startY, endX, endY, delay, onComplete }: WDollarParticleProps) {
  const controlX = startX + (endX - startX) * 0.5;
  const controlY = Math.min(startY, endY) - 100;

  return (
    <motion.div
      className="fixed top-0 left-0 pointer-events-none z-[99999]"
      initial={{
        x: startX,
        y: startY,
        scale: 0,
        opacity: 0,
        rotate: 0,
      }}
      animate={{
        x: [startX, controlX, endX],
        y: [startY, controlY, endY],
        scale: [0, 1.3, 1.1, 0.9, 0],
        opacity: [0, 1, 1, 1, 0],
        rotate: [0, 180, 360, 540],
      }}
      transition={{
        duration: 1.15,
        delay,
        times: [0, 0.15, 0.5, 0.85, 1],
        ease: [0.34, 1.56, 0.64, 1],
      }}
      onAnimationComplete={onComplete}
    >
      <div className="relative">
        <motion.div
          className="absolute inset-0 rounded-full bg-gradient-to-br from-emerald-400 via-green-400 to-teal-500 blur-xl opacity-60"
          animate={{
            scale: [1, 1.8, 1],
            opacity: [0.6, 1, 0.6],
            rotate: [0, 180, 360],
          }}
          transition={{
            duration: 0.6,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-emerald-200 via-green-400 to-emerald-600 flex items-center justify-center shadow-[0_0_25px_rgba(16,185,129,0.8),0_0_40px_rgba(52,211,153,0.4)] border-2 border-emerald-100 relative overflow-hidden">
          <motion.div
            className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent"
            animate={{ x: [-100, 100] }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          />
          <DollarSign className="w-5 h-5 text-emerald-900 relative z-10" />
        </div>
      </div>
    </motion.div>
  );
}
